const data = {
    state: {
        terminal:'pc',
        loginName: '',
        dataInfo:null,
        dataListTable:null,
        language:'',
        Categories:[],
        sortVal:'',
        token:''

    },
    mutations: {
        'SET_TERMINAL': (state, terminal) => { //设置浏览器终端
            state.terminal = terminal
        },
        'SET_LOGINNAME': (state, loginName) => { //存储用户登录名
            state.loginName = loginName
        },
        'SET_DATAINFO': (state, dataInfo) => { //数据详情
            state.dataInfo = dataInfo
        },
        'SET_DATALISTTABLE': (state, dataListTable) => { //数据列表
            state.dataListTable = dataListTable
        },
        'SET_LANGUAGE': (state, language) => { //语言
            state.language = language
        },
        'SET_CATEGORIES': (state, Categories) => { //标签
            state.Categories = Categories
        },
        'SET_SORTVAL': (state, sortVal) => { //排序
            state.sortVal = sortVal
        },
        'SET_TOKEN': (state, token) => { //token
            state.token = token
        },
    }
}
export default data